import React from 'react';
import {
  PROFILE_FILTER_TYPE_MAP,
  PROFILE_FILTER_TYPE,
  PROFILE_FILTER_TYPE_LIST,
} from 'app/constants/profile';
import { POST_FILTER_TYPE } from 'app/entity/post/postConstant';
import clsx from 'clsx';

const ProfileFilterBar = props => {
  const { onClick, selectedFilter, profile } = props;

  const {
    isOpinionWriter,
    opinionsCount,
    parentCommentsCount,
    childCommentsCount,
    questionsCount,
    reviewsCount,
  } = profile;

  const profileCounts = {
    [PROFILE_FILTER_TYPE.OPINIONS]: opinionsCount,
    [POST_FILTER_TYPE.ANSWERED_BY]: parentCommentsCount,
    [POST_FILTER_TYPE.ASKED_BY]: questionsCount,
    [POST_FILTER_TYPE.REPLIED_BY]: childCommentsCount,
    [PROFILE_FILTER_TYPE.REVIEWS]: reviewsCount,
  };

  const selectedFilterTypeList = isOpinionWriter
    ? PROFILE_FILTER_TYPE_LIST
    : PROFILE_FILTER_TYPE_LIST.filter(
        type => type !== PROFILE_FILTER_TYPE.OPINIONS,
      );

  const filterList = selectedFilterTypeList.map(type => {
    const title = `${PROFILE_FILTER_TYPE_MAP[type]} (${profileCounts[type]})`;
    const value = type;
    return {
      title,
      value,
    };
  });

  return (
    <div className="bg-white p-4 rounded w-full">
      <div className="flex gap-5 overflow-x-auto">
        {filterList.map(filter => {
          const isSelected = filter.value === selectedFilter;
          return (
            <span
              key={filter.title}
              className={clsx(
                'text-sm font-bold cursor-pointer whitespace-nowrap',
                isSelected ? 'text-blue-500' : 'text-neutral-500',
              )}
              onClick={() => {
                onClick(filter.value);
              }}
              data-testid={`${filter.value}-filter-button`}
            >
              {filter.title}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default ProfileFilterBar;
